import NumberTitle from "./NumberTitle";

export default NumberTitle;
